














































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CouponModel from "./couponModel.vue";

class PagecouponRequest extends PageRequest {
  couponType: null;
  phoneNumber: "";
}

@Component({
  components: {
    CouponModel
  },
})
export default class coupons extends AbpBase {
  // 编辑按钮事件处理
  edit() {
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PagecouponRequest = new PagecouponRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  couponId:number=0;
  showDetail:boolean=false;
  statusList: Array<any> = [
    {
      value: "0",
      label: "新人券",
    },
    {
      value: "1",
      label: "球场券",
    },
  ];

  get list() {
    return this.$store.state.coupon.list;
  }

  get loading() {
    return this.$store.state.coupon.loading;
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("coupon/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("coupon/setPageSize", pagesize);
    this.getpage();
  }
  openDetail(couponId){
    this.couponId=couponId
    this.showDetail=true;
  }
  search() {
    this.$store.commit("coupon/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "coupon/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.coupon.pageSize;
  }

  get totalCount() {
    return this.$store.state.coupon.totalCount;
  }

  get currentPage() {
    return this.$store.state.coupon.currentPage;
  }
  columns = [
    {
      title: "优惠券类型",
      render: (h: any, params: any) => {
        return h("span", params.row.couponType == 0 ? "新人券" : "球场券");
      },
    },
    {
      title: "优惠券金额",
      key: "amount",
    },
    {
      title: "发放数量",
      key: "quantity",
    },
    {
      title: "开始时间",
      key: "startTime",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.validStartDate).toLocaleString());
      },
    },
    {
      title: "结束时间",
      key: "endTime",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.validEndDate).toLocaleString());
      },
    },
    {
      title: "发放人手机号",
      render: (h: any, params: any) => {
        return h("span", params.row.owner.phoneNumber);
      },
    },
    {
      title: "发放人剩余储值金",
      render: (h: any, params: any) => {
        return h("span", params.row.owner.amount);
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.creationTime).toLocaleString());
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      align: "center",
      slot: "action",
      render: (h: any, params: any) => {
        if (this.hasPermission("Pages.Coupon.Delete")) {
          return h("div", [
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    // this.couponId = params.row.id;
                  this.openDetail(params.row.id);
                  },
                },
              },
              "详情"
            ),
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: this.L("Tips"),
                      content: "确定要删除该记录吗",
                      okText: this.L("Yes"),
                      cancelText: this.L("No"),
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "coupon/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              "删除"
            ),
          ]);
        }
      },
    },
  ];
  async created() {
    this.getpage();
  }
}
